import { Clear } from "@mui/icons-material";
import { IconButton, InputAdornment, InputBaseComponentProps, TextField, TextFieldProps } from "@mui/material";
import { useState } from "react";

type ClearableTextFieldProps = TextFieldProps &{
  fieldName: string,
  fieldValue: any,
  defaultFieldValue: any,
  adornmentText?: string,
  clearFunc: any,
  customInputProps?: InputBaseComponentProps
};

export function ClearableTextField({fieldName, fieldValue, defaultFieldValue, adornmentText, clearFunc, customInputProps, ...props}: ClearableTextFieldProps) {
  const [isFocused, setIsFocused] = useState(false);

  function addClearButton() {
    if (fieldValue === '') {
      return;
    }
      return (
        <IconButton
          onClick={() => clearFunc(fieldName, defaultFieldValue)}
          edge="end"
          onMouseDown={(e) => e.preventDefault()}
        >
            <Clear />
        </IconButton>
    )
  }

  function handleFormEnterKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
      setTimeout(() => {
        (event.target as HTMLInputElement).blur();
      }, 50);
    }
  }


  return (
    <TextField
      {...props}
      name={fieldName}
      fullWidth
      id="outlined-start-adornment"
      value={fieldValue}
      size="small"
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position="end">{adornmentText} {isFocused&&addClearButton()}</InputAdornment>,
        },
      }}
      onKeyDown={handleFormEnterKeyPress}
      inputProps={{
        ...customInputProps,
        enterKeyHint: 'done',
        tabIndex: -1,
      }}
    />
  );
}